import axiosInstance from 'utils/axiosInstance';
import { fixtureApi, fixtureMode } from './fixtures';
import { ILendingCustomer, ILendingInit, ILendingSession, ILoanOffer } from './types';

// REACT_APP_LENDING_API_BASE points TEST at a local stand-in for the gateway (see ceviant-pay-demo's setupProxy.js).
const API_BASE = {
  TEST: process.env.REACT_APP_LENDING_API_BASE || 'https://collections.uat.ceviant.cloud/paymentgateway',
  PROD: 'https://collections.ceviant.cloud/paymentgateway',
};

const SESSION = '/onlending/lending/sessions/current';

/**
 * Every call goes to jm-merchant-collection's public gateway with the session token, which only covers this one
 * application. The SDK never holds the merchant's keys.
 */
let currentMode: ILendingInit['mode'] = 'TEST';

/** The mode the merchant opened the SDK in, which also picks the payment SDK. */
export const apiMode = () => currentMode;

export const configureApi = ({ sessionToken, mode }: ILendingInit) => {
  currentMode = mode;
  axiosInstance.defaults.baseURL = API_BASE[mode];
  axiosInstance.defaults.headers.common['X-Lending-Session'] = sessionToken;
};

export const getSession = async (): Promise<ILendingSession> =>
  fixtureMode() ? fixtureApi.getSession() : (await axiosInstance.get<ILendingSession>(SESSION)).data;

export const updateCustomer = async (customer: ILendingCustomer): Promise<ILendingSession> =>
  fixtureMode() ? fixtureApi.updateCustomer(customer) : (await axiosInstance.put<ILendingSession>(`${SESSION}/customer`, customer)).data;

/** A PDF bank statement, at most 10 MB, base64 encoded, with the code of the bank that issued it. */
export const submitStatement = async (statement: { bankCode: string; contentBase64: string; fileName?: string }): Promise<ILendingSession> =>
  fixtureMode() ? fixtureApi.submitStatement(statement) : (await axiosInstance.post<ILendingSession>(`${SESSION}/statement`, statement)).data;

export const getOffer = async (): Promise<ILoanOffer> =>
  fixtureMode() ? fixtureApi.getOffer() : (await axiosInstance.get<ILoanOffer>(`${SESSION}/offer`)).data;

export const acceptOffer = async (offerId: string, tenor: number): Promise<ILoanOffer> =>
  fixtureMode() ? fixtureApi.acceptOffer(offerId, tenor) : (await axiosInstance.post<ILoanOffer>(`${SESSION}/offer/acceptance`, { offerId, tenor })).data;

export const rejectOffer = async (offerId: string, reason?: string): Promise<ILoanOffer> =>
  fixtureMode() ? fixtureApi.rejectOffer() : (await axiosInstance.post<ILoanOffer>(`${SESSION}/offer/rejection`, { offerId, reason })).data;
